export default "/fonts/SegoeUI-Italic.woff2?b49608de1cfe4f7c87ed6216fa152c00";